import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';
import { TimelineLite } from 'gsap';
import App from 'resizement/scripts/resize';

export class Accordion extends Snappy.BaseComponent {
    static get tagName() {
        return 'cfa-accordion';
    }

    constructor(element) {
        super(element);
    }

    render() {
        this.setVars();

        this.onResize();

        this.$window.on(
            'resize:finished',
            (this.bindedResize = this.onResize.bind(this))
        );


        if (this.isOpened) {
            this.$accordionLink.attr('aria-expanded', true);
        }
    }

    onResize() {
        if (this.isOn && !this.isListenersAdded) {
            this.setEventListeners();
        } else if (!this.isOn && this.isListenersAdded) {
            this.removeEventListeners();
        }
    }

    get isOn() {
        let isOnMobile = !App.isTablet && this.settings.mobile.toString() != 'false',
            isOnTablet =
                App.isTablet &&
                !App.isDesktop &&
                this.settings.tablet.toString() != 'false',
            isOnDesktop =
                App.isDesktop && this.settings.desktop.toString() != 'false',
            isOn = isOnMobile || isOnTablet || isOnDesktop;

        return isOn;
    }

    setVars() {
        this.settings = Object.assign({}, Snappy.Component.Accordion._settings, this.$element.data(), typeof settings == 'undefined' ? {} : settings);

        this.$accordionLink =  this.$element.find('.js-accordion-link').filter((index, el)=> {
            return $(el).parents('[data-cfa-accordion]').first().is(this.$element) ? true : false
        });
        this.$accordionContent = this.$element.find('.js-accordion-content').filter((index, el)=> {
            return $(el).parents('[data-cfa-accordion]').first().is(this.$element) ? true : false
        });
        this.$lazyContent = this.$accordionContent.find('.js-accordion-lazy-content');
        this.preloader = this.$element.find('.js-cfa-preloader');
        this.isOpened = this.$element.hasClass('is-opened');
        this.isAnimating = false;
        this.type = this.$element.data('type');
        this.url = this.$element.data('url');
        this.hasContent = !( this.type === 'lazy' );
        this.isLoading = false;
        this.isExperienceEditor = $('body').hasClass('is-experience-editor');


    }

    setEventListeners() {

        if ( !this.isOpened ) {
            this.$accordionContent.css({
                'max-height': 0,
                'overflow': 'hidden',
                'display': 'none'
            });
        }

        this.$accordionLink.on('click', this.clickListener = this.clickProcess.bind(this));
        this.$accordionLink.on('keydown', this.keydownListener = this.keydownProcess.bind(this));
        this.isListenersAdded = true;
    }

    removeEventListeners() {
        this.$accordionContent.css({
            'max-height': '',
            'overflow': '',
            'display': ''
        });
        this.$accordionLink.off('click', this.clickListener);
        this.$accordionLink.off('keydown', this.keydownListener);
        this.isListenersAdded = false;
    }

    clickProcess(e) {
        if (typeof e !== 'undefined' && typeof e.preventDefault === "function") {
            e.preventDefault();
        }
        if (this.isAnimating) {
            return;
        }

        if ( this.type === 'lazy' &&
            !this.hasContent &&
            !this.isOpened
        ) {
            this.downloadContent();
            return;
        }

        this[this.isOpened  ? "close" : "open"]();
        this.isAnimating = true;

    }

    keydownProcess( event ) {
        const keyCode = event.which;

        switch(keyCode) {
            case 13:
            case 32:
                if ( !this.isExperienceEditor ) {
                    this.clickProcess( event );
                }
                break;
            default:
                break;
        }
    }

    open() {
        if (this.isOpened) {
            this.animationComplete();
            return;
        }

        let $accordionChildren = this.$accordionContent.children();
        if (!$accordionChildren.length)
            return;

        this.$accordionContent.css({
            'display': 'block'
        });

        this.isOpened = true;
        this.$accordionLink.attr('aria-expanded', true);
        this.tween = new TimelineLite({onComplete: this.animationComplete.bind(this)});
        this.tween.fromTo(
            this.$accordionContent,
            this.settings.time, {
                maxHeight: this.$accordionContent.css('max-height')
            }, {
                maxHeight: $accordionChildren.first().outerHeight()
            }
        );
        this.tween.play();
    }

    close() {
        if (!this.isOpened) {
            this.animationComplete();
            return;
        }
        this.isOpened = false;
        this.$accordionLink.attr('aria-expanded', false);

        this.$accordionContent.css({
            'max-height': this.$accordionContent.children().first().outerHeight(),
            'overflow': 'hidden'
        });
        this.$element.removeClass('is-opened');
        this.tween = new TimelineLite({onComplete: this.animationComplete.bind(this)});
        this.tween.to(this.$accordionContent, this.settings.time, { maxHeight: 0 });
        this.tween.play();
    }

    animationComplete() {
        if (this.settings.erase) {
            this.$accordionContent.css({
                'max-height': '',
                'overflow': ''
            });
        } else {
            this.$accordionContent.css('max-height', this.isOpened ? 'none' : '0');
            this.$accordionContent.css('overflow', this.isOpened ? 'visible' : 'hidden');
            this.$accordionContent.css('display', this.isOpened ? 'block' : 'none');
        }

        if (this.isOpened) {
            this.$element.addClass('is-opened');
        }
        this.isAnimating = false;

    }

    downloadContent() {
        this.$lazyContent.html( '' );
        this.isLoading = true;
        this.toggleLoading();
        this.preloader.css( {
            'height': '100px',
            'max-height': '100px'
        } );

        $.ajax( {
            url: this.url,
            type: "GET",
            dataType: "html"
        } ).done( ( data ) => {
            this.$lazyContent.html( data );
            this.hasContent = true;
        } ).fail( () => {
            this.$lazyContent.html( '<div class="no-data">Error getting data from Server. Please contact site administrator or try to reopen accordion again later.</div>' )
        } ).always( () => {
            this.preloader.css( {
                'height': 'auto',
            } );

            this.isLoading = false;
            this.toggleLoading();
            this.open();
        } )
    }

    toggleLoading(){
        this.preloader.toggleClass('cfa-preloader--active', this.isLoading);
    }
};

Snappy.Component.Accordion = Accordion;

Snappy.Component.Accordion._settings = {
    erase: false,
    time: 0.5,
    mobile: true,
    tablet: true,
    desktop: true
};

export default Snappy.Component.Accordion;


// WEBPACK FOOTER //
// ./components/accordion/scripts/accordion.js